import { ChangeDetectionStrategy, Component, signal, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmAlertDialogImports } from '@spartan-ng/helm/alert-dialog';
import { LucideLogOut, LucideTrendingUp, LucideMenu, LucideX } from '@lucide/angular';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    HlmButton,
    HlmAlertDialogImports,
    LucideLogOut,
    LucideTrendingUp,
    LucideMenu,
    LucideX
  ],
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  // Estado del sidebar móvil
  protected readonly mobileSidebarOpen = signal(false);

  // Estado del sidebar en escritorio (expandido/colapsado)
  protected readonly sidebarCollapsed = signal(false);

  openMobileSidebar(): void {
    this.mobileSidebarOpen.set(true);
  }

  closeMobileSidebar(): void {
    this.mobileSidebarOpen.set(false);
  }

  toggleSidebar(): void {
    this.sidebarCollapsed.update((val) => !val);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
